import config from 'config'

export const getLocationPickerPath = (
  mgmtGroupGuid: string | null,
  externalRef: string
) => {
  return mgmtGroupGuid
    ? `https://${
        config.resources.toastOrderHost
      }/online/locations/${mgmtGroupGuid}/${encodeURIComponent(externalRef)}`
    : null
}
